import { render, staticRenderFns } from "./rent_location.vue?vue&type=template&id=823c4ed4"
import script from "./rent_location.vue?vue&type=script&lang=js"
export * from "./rent_location.vue?vue&type=script&lang=js"
import style0 from "./rent_location.vue?vue&type=style&index=0&id=823c4ed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports